import { render } from "./two-factor-auth-dialog.vue?vue&type=template&id=23bb4b80&ts=true"
import script from "./two-factor-auth-dialog.ts?vue&type=script&lang=ts"
export * from "./two-factor-auth-dialog.ts?vue&type=script&lang=ts"

import "./two-factor-auth-dialog.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__